import { graphql } from 'react-apollo';
import { getQuestionsPreview } from 'legacy/src/queries';

const withPreviewQuestions = graphql(getQuestionsPreview, {
  options: ({
    itemId,
    itemIds,
    isSingleQuestionPreview,
    learnosityConfig,
    userData,
    subjectInitId,
  }) => {
    /**
     * for QB created Quiz  preview use the questionIds
     * so we get a learnositySignedRequest with all the item references
     * */
    let graphqlParams = {
      questionId: null,
      questionIds: itemIds,
    };

    if (isSingleQuestionPreview) {
      graphqlParams.questionId = itemId;
    }

    return {
      fetchPolicy: 'network-only',
      variables: {
        ...graphqlParams,
        config: JSON.stringify(learnosityConfig),
        educationPeriod: userData.chosenEducationPeriodCode,
        subjectId: parseInt(subjectInitId, 10),
      },
    };
  },
  props: ({ data }) => {
    const { loading, questionsPreview } = data;

    if (!loading && questionsPreview) {
      const { learnositySignedRequest, allowCalculatorForItems, questions } =
        questionsPreview;
      return {
        loading,
        questions: questions.map((q) => ({ ...q, itemId: q.id })),
        learnosityServerData: JSON.parse(learnositySignedRequest),
        allowCalculatorForItems,
      };
    }
  },
});

export default withPreviewQuestions;
